import React, { useEffect, useState } from 'react';
import { OFFER_SECONDS } from '../utils/checkout';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(OFFER_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? OFFER_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'ORE'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-18" data-mp="3731jcmoa08bb">
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.22em] text-danger sm:text-xs" data-id="element-19" data-mp="10cbt5hb351es">
        L’offerta termina tra
      </p>
      <div className="mt-2.5 flex items-stretch justify-center gap-1.5 sm:gap-2" role="timer" aria-live="off" data-id="element-20" data-mp="15a4yk84kdre0">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-21" data-mp="t2vbv1jllz9j" data-mpi={i}>
            <div className="min-w-[70px] flex-1 rounded-lg border border-white/10 bg-ink-800 px-2 py-2.5 text-center sm:min-w-[86px] sm:flex-none" data-id="element-22" data-mp="t1tpw211nsd1">
              <div className="font-display text-3xl leading-none text-white tabular-nums sm:text-4xl" data-id="element-23" data-mp="12rd9j9wkzq8y">
                {unit.value}
              </div>
              <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-white/45" data-id="element-24" data-mp="f2kh3nf640j3">
                {unit.label}
              </div>
            </div>
            {i < units.length - 1 ? <span className="self-center font-display text-2xl text-accent animate-blink" aria-hidden="true" data-id="element-25" data-mp="o0w7boc4gwb0">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}